import React from 'react';
import TopBar from '../components/redesign/TopBar';
import Navbar from '../components/redesign/Navbar';
import Hero from '../components/redesign/Hero';
import QuickLinks from '../components/redesign/QuickLinks';
import ServicesSection from '../components/redesign/ServicesSection';
import FirstVisit from '../components/redesign/FirstVisit';
import Faq from '../components/redesign/Faq';
import ContactSection from '../components/redesign/ContactSection';
import Footer from '../components/redesign/Footer';
import MobileBar from '../components/redesign/MobileBar';
import '../assets/scss/redesign.scss';

/*
 * Page order follows the approved demo: hero, quick links, services, first visit, FAQs, contact, footer.
 * AccreditationBand, AboutSection, WhoWeServe and CtaBand are kept in components/redesign but no longer rendered.
 */
const Home = () => (
    <div className="sw-redesign">
        <TopBar/>
        <Navbar/>
        <Hero/>
        <QuickLinks/>
        <ServicesSection/>
        <FirstVisit/>
        <Faq/>
        <ContactSection/>
        <Footer/>
        <MobileBar/>
    </div>
);

export default Home;
